<template>
  <div class="contents">
    <div class="create_wrap">
      <div class="create_head">
        <div class="tit">청첩장</div>
      </div>
      <div class="create_body">
        <div class="create_tit">예식 정보 (필수)</div>
        <div class="tbl_wrap">
          <table class="create_tbl">
            <tbody>
              <tr>
                <th>
                  <span>일 자</span>
                </th>
                <td>
                  <div class="wrapper date">
                    <div class="input_wrap">
                      <SelectList
                        v-model="selectedYear"
                        :options="years"
                        unit="년"
                        selectClass="select_box type2"
                      />
                    </div>
                    <div class="input_wrap">
                      <SelectList
                        v-model="selectedMonth"
                        :options="months"
                        unit="월"
                        selectClass="select_box"
                      />
                    </div>
                    <div class="input_wrap">
                      <SelectList
                        v-model="selectedDay"
                        :options="getDayOptions(selectedYear, selectedMonth)"
                        unit="일"
                        selectClass="select_box"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  <span>시간대</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap">
                      <input
                        type="text"
                        placeholder="13:30"
                        v-model="weddingInvitation.eventTime"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr colspan="2">
                <th rowspan="2">
                  <span>예식장명</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap select_box type4">
                      <select class="btn_select ellipsis" v-model="weddingInvitation.partnerSeq" @change="onPartnerChange">
                        <option :value="null">직접입력</option>
                        <option v-for="partner in this.partnerListWithDetails" :key="partner.partnerSeq" :value="partner.partnerSeq">
                          {{ partner.name }}
                        </option>
                      </select>
                    </div>
                    <div class="input_wrap">
                      <input
                        type="text"
                        placeholder="아르떼 웨딩홀"
                        v-model="weddingInvitation.eventLocationName"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap select_box type4">
                      <span class="txt">상세위치</span>
                      <select class="btn_select ellipsis" v-model="selectedPartnerDetailSeq" @change="onPartnerDetailChange" :disabled="!weddingInvitation.partnerSeq">
                        <option :value="null">직접입력</option>
                        <option v-for="detail in partnerDetails" :key="detail.seq" :value="detail.seq">
                          {{ detail.name }}
                        </option>
                      </select>
                    </div>
                    <div class="input_wrap">
                      <input
                        type="text"
                        placeholder="층 / 홀 / 실"
                        v-model="weddingInvitation.eventLocationDetail"
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="create_tit">메인 디자인</div>
        <div class="design_wrap">
          <ul class="list_main">
            <li
              v-for="(item, index) in designs"
              :key="index"
              :class="{ select: item.isSelected }"
              @click="selectMainDesign(index)"
            >
              <div class="img_wrap">
                <img
                  :src="require(`@/assets/images/common/${item.imgSrc}`)"
                  :alt="item.altText"
                />
              </div>
              <a class="btn_choice">선택</a>
            </li>
          </ul>
        </div>
        <div class="tbl_wrap">
          <table class="create_tbl">
            <tbody>
              <tr>
                <th>
                  <span>메인 사진</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap" @click="triggerFileInput('main')">
                      <input
                        type="text"
                        placeholder="이미지를 업로드해주세요."
                        v-model="mainPhoto.name"
                        readonly
                      />
                      <button class="btn_find">찾아보기</button>
                      <input
                        ref="mainFileInput"
                        type="file"
                        style="display: none"
                        @change="handleMainFileChange"
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="create_tit">편집 스타일</div>
        <div class="design_wrap">
          <ul class="list_edit">
            <li
              v-for="(style, index) in editStyles"
              :key="index"
              :class="{ select: style.isSelected }"
            >
              <div class="color_box">
                <div
                  class="color01"
                  :class="{ select: style.selectedColor === 'color01' }"
                  @click="selectEditStyleColor(index, 'color01')"
                ></div>
                <div
                  class="color02"
                  :class="{ select: style.selectedColor === 'color02' }"
                  @click="selectEditStyleColor(index, 'color02')"
                ></div>
                <div
                  class="color03"
                  :class="{ select: style.selectedColor === 'color03' }"
                  @click="selectEditStyleColor(index, 'color03')"
                ></div>
              </div>
              <div
                class="cont_box"
                :class="style.type"
                @click="selectEditStyle(index)"
              >
                <div class="txt_wrap">
                  <div class="top">
                    <div v-if="style.type === 'type2'" class="img">
                      <img
                        :src="require(`@/assets/images/common/${style.imgSrc}`)"
                        alt="Design Image"
                      />
                    </div>
                    <h5 class="main_msg" v-html="style.mainMsg"></h5>
                    <span class="main_eng">{{ style.mainEng }}</span>
                    <p class="sub_msg">
                      두 사람이 사랑으로 만나 <br />
                      진실과 이해로써 하나를 이루려 합니다. <br />
                      여러 어른과 친지분들을 모시고 서약을 맺고자 하오니 <br />
                      바쁘신 가운데 두 사람의 장래를 <br />
                      가까이에서 축복해 주시면 고맙겠습니다.
                    </p>
                  </div>
                  <div class="bottom">
                    <p>Our Family</p>
                    <ul>
                      <li><span>신랑 부</span> 김영수</li>
                      <li><span>신부 부</span> 이철수</li>
                      <li><span>신랑 모</span> 한영희</li>
                      <li><span>신부 모</span> 신영순</li>
                      <li><span>신랑</span> 김하준</li>
                      <li><span>신부</span> 이수연</li>
                    </ul>
                  </div>
                </div>
                <a class="btn_choice">선택</a>
              </div>
            </li>
          </ul>
        </div>
        <div class="create_tit">초대 인사말</div>
        <div class="tbl_wrap">
          <table class="create_tbl">
            <tbody>
              <tr>
                <th>
                  <span>메인 메시지</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="select_box type0">
                      <select
                        class="btn_select ellipsis"
                        v-model="selectedMainMessage"
                      >
                        <option value="">직접입력</option>
                        <option v-for="(msg, index) in mainMessageOptions" :key="index" :value="msg">
                          {{ msg }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="wrapper">
                    <div class="input_wrap type0">
                      <input
                        type="text"
                        placeholder="메인 메시지를 선택하거나 직접 입력하세요."
                        v-model="weddingInvitation.mainMessage"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  <span>인사말</span>
                </th>
                <td>
                  <div class="wrapper type0">
                    <div class="select_box type0">
                      <select
                        class="btn_select ellipsis"
                        v-model="selectedGreetingsMessage"
                      >
                        <option value="">직접입력</option>
                        <option v-for="(msg, index) in greetingsMessageOptions" :key="index" :value="msg">
                          {{ msg }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="wrapper">
                    <textarea class="type0"
                      placeholder="인사말을 선택하거나 직접 입력하세요."
                      v-model="weddingInvitation.greetingsMessage"
                    ></textarea>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="create_tit">혼주 표기</div>
        <div class="tbl_wrap">
          <table class="create_tbl family">
            <tbody>
              <tr>
                <th>
                  <span>신랑측 (부)</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap">
                      <input
                        type="text"
                        placeholder="이름"
                        v-model="weddingInvitation.groomFatherName"
                      />
                      <!-- <div class="select_box type2">
                        <button type="button" class="btn_select">관계</button>
                        <ul class="select_list">
                          <li><button>부</button></li>
                          <li><button>모</button></li>
                          <li><button>조부</button></li>
                          <li><button>조모</button></li>
                        </ul>
                      </div> -->
                    </div>
                  </div>
                </td>
                <th>
                  <span>신부측 (부)</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap">
                      <input
                        type="text"
                        placeholder="이름"
                        v-model="weddingInvitation.brideFatherName"
                      />
                      <!-- <div class="select_box type2">
                        <button type="button" class="btn_select">관계</button>
                        <ul class="select_list">
                          <li><button>부</button></li>
                          <li><button>모</button></li>
                          <li><button>조부</button></li>
                          <li><button>조모</button></li>
                        </ul>
                      </div> -->
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  <span>신랑측 (모)</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap">
                      <input
                        type="text"
                        placeholder="이름"
                        v-model="weddingInvitation.groomMotherName"
                      />
                      <!-- <div class="select_box type2">
                        <button type="button" class="btn_select">관계</button>
                        <ul class="select_list">
                          <li><button>부</button></li>
                          <li><button>모</button></li>
                          <li><button>조부</button></li>
                          <li><button>조모</button></li>
                        </ul>
                      </div> -->
                    </div>
                  </div>
                </td>
                <th>
                  <span>신부측 (모)</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap">
                      <input
                        type="text"
                        placeholder="이름"
                        v-model="weddingInvitation.brideMotherName"
                      />
                      <!-- <div class="select_box type2">
                        <button type="button" class="btn_select">관계</button>
                        <ul class="select_list">
                          <li><button>부</button></li>
                          <li><button>모</button></li>
                          <li><button>조부</button></li>
                          <li><button>조모</button></li>
                        </ul>
                      </div> -->
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  <span>신랑 이름</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap">
                      <input
                        type="text"
                        placeholder="이름"
                        v-model="weddingInvitation.groomName"
                      />
                    </div>
                  </div>
                </td>
                <th>
                  <span>신부 이름</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap">
                      <input
                        type="text"
                        placeholder="이름"
                        v-model="weddingInvitation.brideName"
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="create_tit">혼주 연락처</div>
        <div class="tbl_wrap">
          <table class="create_tbl">
            <tbody>
              <tr>
                <th>
                  <span>신랑측</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap">
                      <input
                        type="text"
                        placeholder="이름"
                        v-model="weddingInvitation.groomContactName"
                      />
                      <input
                        type="text"
                        placeholder="연락처 (- 없이 입력)"
                        v-model="weddingInvitation.groomContactPhone"
                        inputmode="numeric" pattern="\d*" maxlength="11" 
                        @input="weddingInvitation.groomContactPhone = (weddingInvitation.groomContactPhone || '').replace(/\D/g,'')"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  <span>신부측</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap">
                      <input
                        type="text"
                        placeholder="이름"
                        v-model="weddingInvitation.brideContactName"
                      />
                      <input
                        type="text"
                        placeholder="연락처 (- 없이 입력)"
                        v-model="weddingInvitation.brideContactPhone"
                        inputmode="numeric" pattern="\d*" maxlength="11" 
                        @input="weddingInvitation.brideContactPhone = (weddingInvitation.brideContactPhone || '').replace(/\D/g,'')"
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="create_tit">사진 갤러리</div>
        <div class="design_wrap">
          <ul class="list_gallery">
            <li
              @click="selectGallery(1)"
              :class="weddingInvitation.galleryType == 1 ? 'select' : ''"
              style="display:none;"
            >
              <div class="img_wrap">
                <div class="quarter">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <a href="">더보기</a>
              </div>
              <a class="btn_choice">선택</a>
            </li>
            <li
              @click="selectGallery(2)"
              :class="weddingInvitation.galleryType == 2 ? 'select' : ''"
            >
              <div class="img_wrap">
                <div class="preview"></div>
                <ul class="thumb">
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
              </div>
              <a class="btn_choice">선택</a>
            </li>
            <li>
              <div class="img_wrap">
                <button
                  class="btn_photoAdd"
                  @click="triggerFileInput('gallery')"
                ></button>
                <input
                  type="file"
                  ref="fileInput"
                  accept="image/*"
                  multiple
                  @change="handleFileChange"
                  style="display: none"
                />
              </div>
              <p>
                갤러리 사진 업로드
                <span>( {{ attachList.length }} / 12 )</span>
              </p>
            </li>
            <li v-for="(attach, index) in attachList" :key="index">
              <div class="img_wrap">
                <img :src="$getImgUrl(attach.path)" alt="미리보기 이미지" v-if="attach.weddingInvitationAttachSeq"/>
                <img :src="attach.preview" alt="미리보기 이미지" v-else/>
              </div>
              <a class="btn_delete" @click="removeAttach(index)"></a>
            </li>
          </ul>
        </div>
        <div class="create_tit">안내 사항</div>
        <p>전세 버스, 피로연, 화환 등의 안내 사항을 기재하실 수 있습니다.</p>
        <div class="example">
          <span>· 예) 본 예식은 예배 형식으로 드려집니다. 정숙한 참여를 부탁드립니다.</span>
          <span>· 예) 예식장 지하 1층 주차장 이용 시 무료주차 2시간 가능</span>
          <span>· 예) 발렛파킹이 제공됩니다. (2시간 무료)</span>
        </div>
        <div class="tbl_wrap">
          <table class="create_tbl">
            <tbody>
              <!--
              <tr>
                <th>
                  <span>제목</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap type1">
                      <input
                        type="text"
                        placeholder="제목"
                        v-model="weddingInvitation.guideTitle"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  <span>내용</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap type1">
                      <input
                        type="text"
                        placeholder="내용"
                        v-model="weddingInvitation.guideContent"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              -->
              <tr>
                <th>
                  <span>안내사항</span>
                </th>
                <td>
                  <div class="wrapper type0">
                    <div class="select_box type0">
                      <select
                        class="btn_select ellipsis"
                        @change="appendNotice($event)"
                      >
                        <option value="">직접입력</option>
                        <option v-for="(msg, index) in noticeMessageOptions" :key="index" :value="msg">
                          {{ msg }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="wrapper">
                    <textarea class="type0"
                      placeholder="안내사항을 선택하거나 직접 입력하세요."
                      v-model="weddingInvitation.noticeMessage"
                    ></textarea>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="create_tit">축하의 마음 전하기 (송금받기)</div>
        <div class="example">
          <span>· 예) 바쁘신 가운데 축하해주시는 마음, 감사히 받겠습니다.</span>
          <span>· 예) 부득이하게 함께하지 못하셔도 마음으로 축하해주심에 진심으로 감사드립니다.</span>
          <span>· 예) 귀한 축하의 마음을 전해주심에 깊이 감사드립니다.</span>
        </div>
        <div class="tbl_wrap">
          <table class="create_tbl">
            <tbody>
              <tr>
                <th>
                  <span>메시지</span>
                </th>
                <td>
                  <div class="wrapper type0">
                    <div class="select_box type0">
                      <select
                        class="btn_select ellipsis"
                        v-model="selectedThankyouMessage"
                      >
                        <option value="">직접입력</option>
                        <option v-for="(msg, index) in thankyouMessageOptions" :key="index" :value="msg">
                          {{ msg }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="wrapper">
                    <div class="input_wrap type0">
                      <input
                        type="text"
                        placeholder="축하의 마음을 담아 축의금을 전달해 보세요."
                        v-model="weddingInvitation.thankyouMessage"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  <span>신랑측</span>
                </th>
                <td>
                  <div
                    class="wrapper"
                    v-for="(congratInfo, index) in groomCongratInfo"
                  >
                    <div class="input_wrap">
                      <input
                        type="text"
                        placeholder="신랑측 이름"
                        v-model="congratInfo.name"
                      />
                      <input
                        type="text"
                        placeholder="은행명"
                        v-model="congratInfo.bankName"
                      />
                      <input
                        type="text"
                        placeholder="계좌 번호"
                        v-model="congratInfo.bankNumber"
                        inputmode="numeric" pattern="\d*" 
                        @input="congratInfo.bankNumber = (congratInfo.bankNumber || '').replace(/\D/g,'')"
                      />
                      <input
                        type="text"
                        placeholder="전화 번호"
                        v-model="congratInfo.phoneNumber"
                        inputmode="numeric" pattern="\d*" maxlength="11" 
                        @input="congratInfo.phoneNumber = (congratInfo.phoneNumber || '').replace(/\D/g,'')"
                      />
                    </div>
                    <div class="btn_box">
                      <a class="btn_del" @click="removeRow('groom', index)"></a>
                      <a
                        class="btn_add"
                        @click="addRow('groom')"
                        v-if="index === 0"
                      ></a>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  <span>신부측</span>
                </th>
                <td>
                  <div
                    class="wrapper"
                    v-for="(congratInfo, index) in brideCongratInfo"
                  >
                    <div class="input_wrap">
                      <input
                        type="text"
                        placeholder="신부측 이름"
                        v-model="brideCongratInfo[index].name"
                      />
                      <input
                        type="text"
                        placeholder="은행명"
                        v-model="brideCongratInfo[index].bankName"
                      />
                      <input
                        type="text"
                        placeholder="계좌 번호"
                        v-model="brideCongratInfo[index].bankNumber"
                        inputmode="numeric" pattern="\d*" 
                        @input="brideCongratInfo[index].bankNumber = (brideCongratInfo[index].bankNumber || '').replace(/\D/g,'')"
                      />
                      <input
                        type="text"
                        placeholder="전화 번호"
                        v-model="brideCongratInfo[index].phoneNumber"
                        inputmode="numeric" pattern="\d*" maxlength="11" 
                        @input="brideCongratInfo[index].phoneNumber = (brideCongratInfo[index].phoneNumber || '').replace(/\D/g,'')"
                      />
                    </div>
                    <div class="btn_box">
                      <a class="btn_del" @click="removeRow('bride', index)"></a>
                      <a
                        class="btn_add"
                        @click="addRow('bride')"
                        v-if="index === 0"
                      ></a>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="create_tit">디지털 기부 화환 설정</div>
        <p>
          디지털 기부 화환은 근조 화환을 디지털 화환으로 제공 되는 서비스
          입니다.
        </p>
        <p>
          디지털 화환의 결제 금액의 일부는 다양한 사회적 활동에 기부가 됩니다.
        </p>
        <div class="tbl_wrap">
          <table class="create_tbl">
            <tbody>
              <tr style="display:none;">
                <th>
                  <span>기부 화환 적용</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="form_wrap">
                      <label for="apply" class="radio_wrap">
                        <input
                          type="radio"
                          id="apply"
                          name="apply"
                          v-model="weddingInvitation.useCampaign"
                          :value="true"
                        />
                        <span>적용</span>
                      </label>
                      <label for="applyNot" class="radio_wrap">
                        <input
                          type="radio"
                          id="applyNot"
                          name="apply"
                          v-model="weddingInvitation.useCampaign"
                          :value="false"
                        />
                        <span>미적용</span>
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              <!--
              <tr v-if="weddingInvitation.useCampaign">
                <th>
                  <span>분류</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap">
                      <div class="select_box type3">
                        <select
                          type="button"
                          class="btn_select"
                          v-model="currentCategorySeq"
                        >
                          <option value="">전체</option>
                          <option
                            v-for="category in categories"
                            :key="category.categorySeq"
                            :value="category.categorySeq"
                          >
                            {{ category.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              -->
              <tr v-if="weddingInvitation.useCampaign">
                <th>
                  <span>카테고리</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap">
                      <div class="select_box type4">
                        <select class="btn_select" v-model="selected1DepthCampaignCategorySeq">
                          <option :value="null">상위 카테고리 선택</option>
                          <option v-for="category in campaignCategoryListWithChildren" :key="category.seq" :value="category.seq">
                            {{ category.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="input_wrap">
                      <div class="select_box type4">
                        <select class="btn_select" v-model="weddingInvitation.categoryCampaignSeq" :disabled="!selected1DepthCampaignCategorySeq">
                          <option :value="null">하위 카테고리 선택</option>
                          <option v-for="child in campaignCategories2Depth" :key="child.seq" :value="child.seq">
                            {{ child.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="weddingInvitation.useCampaign">
                <th>
                  <span>기부처</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap">
                      <div class="select_box type4">
                        <select class="btn_select" v-model="selected1DepthDonationCategorySeq">
                          <option :value="null">상위 기부처 선택</option>
                          <option v-for="category in donationCategoryListWithChildren" :key="category.seq" :value="category.seq">
                            {{ category.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="input_wrap">
                      <div class="select_box type4">
                        <select class="btn_select" v-model="weddingInvitation.categoryDonationSeq" :disabled="!selected1DepthDonationCategorySeq">
                          <option :value="null">하위 기부처 선택</option>
                          <option v-for="child in donationCategories2Depth" :key="child.seq" :value="child.seq">
                            {{ child.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="weddingInvitation.useCampaign">
                <th>
                  <span>캠페인 선택</span>
                </th>
                <td>
                  <ul class="list_campaign">
                    <li
                      v-for="(campaign, index) in filteredCampaigns"
                      :key="index"
                      :class="{
                        select:
                          weddingInvitation.campaignSeq ===
                          campaign.campaignSeq,
                      }"
                      @click="selectCampaign(campaign.campaignSeq)"
                    >
                      <div class="img_wrap">
                        <img
                          :src="
                            campaign.thumbnailPath
                              ? $getImgUrl(campaign.thumbnailPath)
                              : require('../../assets/images/common/campaign_img_01.png')
                          "
                          alt=""
                        />
                      </div>
                      <div class="txt_wrap">
                        [{{ campaign.partnerCompany }}]
                        {{ campaign.campaignName }}
                      </div>
                      <a class="btn_choice">선택</a>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr v-if="weddingInvitation.useCampaign">
                <th>
                  <span>키오스크 화면</span>
                </th>
                <td>
                  <div class="design_wrap">
                    <ul class="list_kiosk">
                      <li
                        v-for="style in kioskStyles"
                        :key="style.id"
                        :class="{ select: String(weddingInvitation.kioskStyle) === String(style.id) }"
                        @click="selectKioskStyle(style.id)"
                      >
                        <div class="img_wrap">
                          <img
                            :src="require(`@/assets/images/common/${style.imgSrc}`)"
                            :alt="style.altText"
                          />
                        </div>
                        <a class="btn_choice">선택</a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="create_tit" v-if="!isAuthenticated">비회원 계정 생성</div>
        <span v-if="!isAuthenticated"
          >· 비회원으로 생성 시 이름, 전화번호, 주문번호가 비회원 로그인에
          사용됩니다.</span
        >
        <div class="tbl_wrap" v-if="!isAuthenticated">
          <table class="create_tbl">
            <tbody>
              <tr>
                <th>
                  <span>이름</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap type1">
                      <input
                        type="text"
                        placeholder="이름"
                        v-model="weddingInvitation.nonMemberName"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  <span>전화번호</span>
                </th>
                <td>
                  <div class="wrapper">
                    <div class="input_wrap type1">
                      <input
                        type="text"
                        placeholder="전화번호"
                        v-model="weddingInvitation.nonMemberPhone"
                        inputmode="numeric" pattern="\d*" maxlength="11" 
                        @input="weddingInvitation.nonMemberPhone = (weddingInvitation.nonMemberPhone || '').replace(/\D/g,'')"
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="create_tit">기타 설정 (오시는 길)</div>
        <div class="tbl_wrap">
          <table class="create_tbl">
            <tbody>
              <tr>
                <th>
                  <span>카카오맵 사용</span>
                </th>
                <td>
                  <div class="wrapper">
                    <span class="search_box">
                      <input
                        type="text"
                        placeholder="결혼식장 검색"
                        name="keyword"
                        @keyup.enter="searchPlace"
                        v-model="name"
                      />
                      <button type="button" @click="searchPlace">
                        검색버튼
                      </button>
                    </span>
                    <p>· 생성 이후 마이페이지에서 확인 가능합니다.</p>
                  </div>
                  <ul>
                    <li
                      v-for="place in places"
                      :key="place.id"
                      @click="selectPlace(place)"
                    >
                      {{ place.place_name }}
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th></th>
                <td>
                  <div id="map" style="width: 95%; height: 400px"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="create_button">
        <button type="button" class="btn_preview">미리보기</button>
        <button type="button" class="btn_save" @click="create">저장하기</button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import SelectList from "../common/SelectList.vue";

const campaignModule = "campaignModule";
const categoryModule = "categoryModule";
const weddingModule = "weddingModule";
const accountModule = "accountModule";
const partnerModule = 'partnerModule';
const campaignCategoryModule = 'campaignCategoryModule';
const donationCategoryModule = 'donationCategoryModule';

export default {
  components: {
    SelectList,
  },

  props: {
    weddingInvitationSeq: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      years: this.getYearOptions(),
      months: this.getMonthOptions(),
      days: [],
      selectedYear: '',
      selectedMonth: '',
      selectedDay: '',

      designs: [
        { imgSrc: "wedding_img_01.png", altText: "Image 1" },
        { imgSrc: "wedding_img_02.png", altText: "Image 2" },
        { imgSrc: "wedding_img_03.png", altText: "Image 3" },
        { imgSrc: "wedding_img_04.png", altText: "Image 4" },
      ],

      editStyles: [
        {
          type: "type1",
          mainMsg: "결혼합니다.",
          mainEng: "JOIN US FOR THE WEDDING",
          isSelected: false,
          selectedColor: null,
        },
        {
          type: "type2",
          imgSrc: "ico_edit_02.png",
          mainMsg: "두사람, 결혼합니다.",
          mainEng: "",
          isSelected: false,
          selectedColor: null,
        },
        {
          type: "type3",
          mainMsg: "두사람, 결혼합니다.",
          mainEng: "Join us for the wedding",
          isSelected: false,
          selectedColor: null,
        },
        {
          type: "type4",
          mainMsg: `우리 <br /> 결혼합니다`,
          mainEng: "",
          isSelected: false,
          selectedColor: null,
        },
      ],

      currentPage: 1,
      currentCategorySeq: "",
      places: [],
      name: "",
      map: null,

      weddingInvitation: {
        eventDate: '',
        eventTime: "",
        eventLocationName: "",
        eventLocationDetail: "",

        mainDesign: 1,
        editStyle: "0_color01",
        galleryType: 2,

        mainMessage: "",
        greetingsMessage: "",

        groomFatherName: "",
        groomMotherName: "",
        groomName: "",
        brideFatherName: "",
        brideMotherName: "",
        brideName: "",

        groomContactName: "",
        groomContactPhone: "",
        brideContactName: "",
        brideContactPhone: "",

        thankyouMessage: "",
        guideTitle: "",
        guideContent: "",

        useCampaign: true,
        campaignSeq: "",

        eventLatitude: 37.5665,
        eventLongitude: 126.978,
        mapAddress: "",

        nonMemberName: "",
        nonMemberPhone: "",

        kioskStyle: 1,

        noticeMessage: "",

        partnerSeq: null,
        categoryCampaignSeq: null,
        categoryDonationSeq: null
      },

      groomCongratInfo: [

      ],

      brideCongratInfo: [

      ],

      mainPhoto: {
        name: "",
        type: "main",
        file: null,
      },

      attachList: [],
      deletedAttachSeqs: [],

      mainMessageOptions: [
        '함께 걷는 첫날',
        '사랑, 약속이 되다',
        '당신과 함께여서 더 기쁜 날',
        '서로의 눈빛에서 같은 미래를 보았습니다.',
        '우리의 사랑이 한 그루 나무처럼 자랐습니다.',
        '이제, 평생 서로의 ‘좋아요’를 누릅니다.',
        '하나님 안에서 하나 되어 나아갑니다',
        '하나님께서 만드신 첫 교회, 가정을 이루려 합니다.',
        '둘이 한 몸을 이루리라',
        '하나님께서 허락하신 만남, 그 사랑으로 한 가정을 이루려 합니다.',
        '믿음 안에서 만나 사랑으로 동행합니다.',
        '신실하신 주님 안에서 우리의 가정을 세웁니다.'
      ],
      greetingsMessageOptions: [
        '두 사람이 함께 걸어갈 긴 여정의 첫날에 기도와 축복으로 함께해주세요.',
        '오랜 사랑이 하나의 약속이 되었습니다. 그 시작의 자리에 소중한 당신을 초대합니다.',
        '서로를 향한 마음을 믿고 하나가 되기로 약속했습니다. 함께 해주신다면 큰 기쁨이 될 것입니다.',
        '저희 두 사람이 하나가 되는 소중한 날, 귀한 걸음으로 축복해 주시면 큰 기쁨이 되겠습니다.',
        '새로운 삶의 출발선에 선 저희, 믿음과 사랑으로 한 걸음을 내딛으려 합니다. 부디 오셔서 따뜻한 격려와 축복을 나눠주세요.',
        '봄 햇살처럼 따뜻한 하루, 저희의 사랑이 결실을 맺는 날입니다. 기도로 축복해주시고 함께해주신다면 더 없는 기쁨이겠습니다',
        '사랑의 이름으로 만나 믿음으로 함께하려 합니다. 저희의 첫걸음에 따뜻한 축복을 부탁드립니다.',
        '일상의 언어로 사랑을 쌓아온 저희가 이제 한 가정을 이루려 합니다. 귀한 분께서 함께 해주시길 기다립니다.',
        '계절이 바뀌고 햇살이 깊어지듯 저희의 사랑도 단단해졌습니다. 결실의 날에 함께 해주신다면 큰 기쁨이겠습니다.',
        '친구로 시작해 연인이 되고 이제 인생의 동반자가 되려 합니다. 저희의 시작을 축복해주시면 감사하겠습니다.',
        '주님의 인도하심으로 만난 저희, 믿음의 가정으로 첫 발걸음을 내딛습니다. 함께 기도해주시고 축복해주신다면 더없는 축복이 되겠습니다.',
        '“사랑은 모든 것을 믿으며 모든 것을 바라며 모든 것을 견디느니라”(고린도전서 13:7)\n하나님의 사랑으로 만나 믿음의 가정을 세우고자 합니다. 귀한 걸음으로 축복해주신다면 감사하겠습니다.',
        '“이러므로 사람이 부모를 떠나 그의 아내와 합하여 둘이 한 몸을 이룰지니”(에베소서 5:31)\n주 안에서 사랑으로 하나 되어 가정을 이루고자 합니다. 함께 해주시어 축복해주시길 소망합니다.',
        '서로를 향한 믿음과 기도로 결혼이라는 은혜의 자리를 준비했습니다. 함께 축복해주시면 감사하겠습니다.',
        '저희 두 사람이 주님 안에서 하나 되어 결혼합니다. 이 뜻깊은 자리에 함께 해주시어 격려와 축복을 나눠주시길 부탁드립니다.',
        '기도로 준비한 저희의 시작을 하나님 앞에서 고백하고자 합니다. 귀한 발걸음으로 함께해 주신다면 큰 기쁨과 감사가 되겠습니다.'
      ],
      thankyouMessageOptions: [
        '바쁘신 가운데 축하해주시는 마음, 감사히 받겠습니다.',
        '부득이하게 함께하지 못하셔도 마음으로 축하해주심에 진심으로 감사드립니다.',
        '귀한 축하의 마음을 전해주심에 깊이 감사드립니다.'
      ],
      noticeMessageOptions: [
        '실물화환은 정중히 사양합니다. 디지털 기부화환으로 축하의 마음을 전해주세요.'
      ],

      kioskStyles: [
        { id: 1, imgSrc: "kiosk_style_wedding_01.png", altText: "키오스크 스타일 1" },
        { id: 2, imgSrc: "kiosk_style_wedding_02.png", altText: "키오스크 스타일 2" },
        { id: 3, imgSrc: "kiosk_style_wedding_03.png", altText: "키오스크 스타일 3" },
        { id: 4, imgSrc: "kiosk_style_wedding_04.png", altText: "키오스크 스타일 4" }
      ],

      selectedPartnerDetailSeq: null,
      selected1DepthCampaignCategorySeq: null,
      selected1DepthDonationCategorySeq: null
    };
  },

  methods: {
    ...mapActions(campaignModule, ["requestCampaignList", "requestFilteredCampaignList"]),
    ...mapActions(categoryModule, ["requestCategoryList"]),
    ...mapActions(weddingModule, ["requestWeddingInvitationForEdit", "requestWeddingInvitationEdit"]),
    ...mapActions(accountModule, ["requestCheckLogin"]),
    ...mapActions(partnerModule, ['requestPartnersWithDetails']),
    ...mapActions(campaignCategoryModule, ['requestCampaignCategoryListWithChildren']),
    ...mapActions(donationCategoryModule, ['requestDonationCategoryListWithChildren']),

    selectEditStyle(idx) {
      this.editStyles.forEach((style, i) => {
        style.isSelected = i === idx;
        style.selectedColor = i === idx ? "color01" : null;
      });

      this.weddingInvitation.editStyle = idx + "_color01";
    },

    selectEditStyleColor(idx, color) {
      this.editStyles.forEach((style, i) => {
        style.isSelected = i === idx;
        style.selectedColor = i === idx ? color : null;
      });
      this.weddingInvitation.editStyle = idx + "_" + color;
    },

    selectMainDesign(idx) {
      this.designs.forEach((design, i) => {
        design.isSelected = i === idx;
      });

      this.weddingInvitation.mainDesign = idx + 1;
    },

    selectGallery(idx) {
      this.weddingInvitation.galleryType = idx + 1;
    },

    triggerFileInput(fileType) {
      if (fileType === "main") {
        this.$refs.mainFileInput.click();
      } else {
        this.$refs.fileInput.click();
      }
    },

    handleMainFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.mainPhoto.name = file.name;
        this.mainPhoto.type = "main";
        this.mainPhoto.file = file;
      }
      this.deletedAttachSeqs.push(this.weddingInvitation.mainImageSeq)
    },

    handleFileChange(event) {
      const files = event.target.files;
      if (!files.length) return;
      if (files.length > 12) {
        this.$openModal("alertModal", {
          message: "사진은 최대 12장만 업로드 가능합니다.",
        });
        return;
      }

      const newFiles = Array.from(files).map((file) => ({
        name: file.name,
        file: file,
        preview: URL.createObjectURL(file),
      }));
      this.attachList = [...this.attachList, ...newFiles];
    },

    removeAttach(idx) {
      const file = this.attachList[idx];

      if (file?.weddingInvitationAttachSeq) this.deletedAttachSeqs.push(file.weddingInvitationAttachSeq);
      this.attachList.splice(idx, 1);
    },

    async getCategorizedCampaign(categorySeq) {
      this.currentPage = 1;
      this.currentCategorySeq = categorySeq;

      const { currentPage, currentCategorySeq } = this;
      await this.requestCampaignList({ currentPage, currentCategorySeq });
    },

    selectCampaign(campaignSeq) {
      this.weddingInvitation.campaignSeq = campaignSeq;
    },

    addRow(side) {
      if (side === "bride") {
        this.brideCongratInfo.push({ weddingSide: "bride" });
      } else {
        this.groomCongratInfo.push({ weddingSide: "groom" });
      }
    },

    removeRow(side, idx) {
      if (side === "bride") {
        if (this.brideCongratInfo.length === 1)
          this.brideCongratInfo.push({ weddingSide: "bride" });
        this.brideCongratInfo.splice(idx, 1);
      } else {
        if (this.groomCongratInfo.length === 1)
          this.groomCongratInfo.push({ weddingSide: "groom" });
        this.groomCongratInfo.splice(idx, 1);
      }
    },

    initMap(x, y) {
      var container = document.getElementById("map");
      var options = {
        center: new kakao.maps.LatLng(x, y),
        level: 4,
        draggable: false,
      };
      this.map = new kakao.maps.Map(container, options);
    },

    searchPlace() {
      const ps = new kakao.maps.services.Places();
      ps.keywordSearch(this.name, (data, status) => {
        if (status === kakao.maps.services.Status.OK) {
          this.places = data;
        }
      });
    },

    async selectPlace(place) {
      this.name = place.place_name;
      this.weddingInvitation.eventLatitude = place.y;
      this.weddingInvitation.eventLongitude = place.x;
      this.weddingInvitation.mapAddress = place.address_name;

      const newPosition = new kakao.maps.LatLng(place.y, place.x);

      if (this.marker) {
        this.marker.setMap(null);
        this.marker = null;
      }
      if (this.infoWindow) {
        this.infoWindow.close();
        this.infoWindow = null;
      }

      this.marker = new kakao.maps.Marker({
        position: newPosition,
        map: this.map,
      });

      if (this.map) {
        this.map.setCenter(new kakao.maps.LatLng(place.y, place.x));
      }

      if (this.name) {
        this.infoWindow = new kakao.maps.InfoWindow({
          content: `<div style="padding:5px;font-size:14px;">${place.place_name}</div>`,
        });
        this.infoWindow.open(this.map, this.marker);
      }
    },

    async create() {
      const {
        weddingInvitation,
        groomCongratInfo,
        brideCongratInfo,
        mainPhoto,
        attachList,
      } = this;
      const attachMetaList = [];
      weddingInvitation.greetingsMessage =
        weddingInvitation.greetingsMessage.replace(/\n/g, "<br>");
      const congratInfo = [...groomCongratInfo, ...brideCongratInfo];
      weddingInvitation.congratInfo = congratInfo;
      weddingInvitation.weddingInvitationSeq = this.weddingInvitationSeq

      const formData = new FormData();
      formData.append(
        "weddingInvitation",
        new Blob([JSON.stringify(weddingInvitation)], {
          type: "application/json",
        })
      );

      if (this.weddingInvitation.useCampaign && !this.weddingInvitation.categoryCampaignSeq) {
        alert("캠페인 카테고리를 선택해주세요.");
        return;
      }

      if (this.weddingInvitation.useCampaign && !this.weddingInvitation.categoryDonationSeq) {
        alert("기부처를 선택해주세요.");
        return;
      }

      if (this.weddingInvitation.useCampaign && !this.weddingInvitation.campaignSeq) {
        alert("캠페인을 선택해주세요.");
        return;
      }

      if (mainPhoto.file) {
        formData.append("attachList", mainPhoto.file);
        attachMetaList.push({
          name: mainPhoto.name,
          type: "main"
        });
      }
      attachList.forEach((attach) => {
        if (attach.file) formData.append("attachList", attach.file);
        attachMetaList.push({
          name: attach.name
        });
      });
      formData.append("attachMetaList", new Blob([JSON.stringify(attachMetaList)], { type: "application/json" }));
      formData.append("deletedAttachSeqs", new Blob([JSON.stringify(this.deletedAttachSeqs)], { type: "application/json" }));

      const result = await this.requestWeddingInvitationEdit(formData);
      if (result) {
        this.$openModal("alertModal", {
          message:
            "청첩장이 수정되었습니다."
        });
        this.$router.push({
          name: "InvitationViewPage",
          params: { orderNum: result },
        });
      };

      const script = document.createElement("script");
      script.src = "//dapi.kakao.com/v2/maps/sdk.js?appkey=d85cbed7c60b4a3778aac81af3b24690&libraries=services";
      document.head.appendChild(script);
      script.onload = () => {
          kakao.maps.load(() => {
              const node = document.getElementById('map'); // 지도를 표시할 div
              const center = new kakao.maps.LatLng(37.50802, 127.062835);
              const options = {
                  center,
                  level: 3
              };
              const map = new kakao.maps.Map(node, options);
          });
      };

    },

    getYearOptions() {
      const currentYear = new Date().getFullYear();
      return Array.from({ length: 10 }, (_, i) => String(currentYear + i));
    },

    getMonthOptions() {
      return Array.from({ length: 12 }, (_, i) => String(i + 1));
    },

    getDayOptions(year, month) {
      const daysInMonth = new Date(year, month, 0).getDate();
      return Array.from({ length: daysInMonth }, (_, i) => String(i + 1));
    },

    selectKioskStyle(kioskStyleId) {
      this.weddingInvitation.kioskStyle = kioskStyleId;
    },

    appendNotice(e) {
      const msg = (e.target.value || '').trim()
      if (!msg) return

      const cur = (this.weddingInvitation.noticeMessage || '').toString().trimEnd()
      this.weddingInvitation.noticeMessage = cur ? `${cur}\n${msg}` : msg

      e.target.value = ''
    },

    onPartnerChange() {
      this.selectedPartnerDetailSeq = null;
      this.weddingInvitation.eventLocationDetail = '';

      if (this.weddingInvitation.partnerSeq) {
        const selectedPartner = this.partnerListWithDetails.find(p => p.partnerSeq === this.weddingInvitation.partnerSeq);
        this.weddingInvitation.eventLocationName = selectedPartner.name;
        // 선택된 결혼식장으로 이동
        this.updateMapByName(this.weddingInvitation.eventLocationName);
      } else {
        this.weddingInvitation.eventLocationName = '';
      }
    },

    onPartnerDetailChange() {
      if (this.selectedPartnerDetailSeq) {
        const selectedDetail = this.partnerDetails.find(d => d.seq === this.selectedPartnerDetailSeq);
        this.weddingInvitation.eventLocationDetail = selectedDetail.name;
      } else {
        this.weddingInvitation.eventLocationDetail = '';
      }
    },

    updateMapByName(name) {
      const keyword = (name || '').trim();
      if (!keyword) return;

      const ps = new kakao.maps.services.Places();
      ps.keywordSearch(keyword, (data, status) => {
        if (status === kakao.maps.services.Status.OK && data.length > 0) {
          // 첫 번째 검색 결과로 이동
          const place = data[0];
          this.selectPlace(place);
          // 검색 결과 리스트는 초기화(선택 UI 깔끔하게)
          this.places = [];
        }
      });
    },    

    findCampaignCategoryParentSeq(childSeq) {
      for (const parent of this.campaignCategoryListWithChildren) {
        if (parent.children.some(child => child.seq === childSeq)) {
          return parent.seq;
        }
      }
      return null;
    },

    findDonationCategoryParentSeq(childSeq) {
      for (const parent of this.donationCategoryListWithChildren) {
        if (parent.children.some(child => child.seq === childSeq)) {
          return parent.seq;
        }
      }
      return null;
    }
  },

  computed: {
    ...mapState(campaignModule, ["campaigns", "campaignCount", "filteredCampaigns"]),
    ...mapState(categoryModule, ["categories"]),
    ...mapState(accountModule, ["isAuthenticated"]),
    ...mapState(partnerModule, ["partnerListWithDetails"]),
    ...mapState(campaignCategoryModule, ['campaignCategoryListWithChildren']),
    ...mapState(donationCategoryModule, ['donationCategoryListWithChildren']),

    eventDate() {
      return `${this.selectedYear}-${String(this.selectedMonth).padStart(
        2,
        "0"
      )}-${String(this.selectedDay).padStart(2, "0")}`;
    },

    selectedMainMessage: {
      get() {
        if (this.mainMessageOptions.includes(this.weddingInvitation.mainMessage)) {
          return this.weddingInvitation.mainMessage;
        }
        return '';
      },
      set(newValue) {
        this.weddingInvitation.mainMessage = newValue;
      }
    },
    selectedGreetingsMessage: {
      get() {
        if (this.greetingsMessageOptions.includes(this.weddingInvitation.greetingsMessage)) {
          return this.weddingInvitation.greetingsMessage;
        }
        return '';
      },
      set(newValue) {
        this.weddingInvitation.greetingsMessage = newValue;
      }
    },
    selectedThankyouMessage: {
      get() {
        if (this.thankyouMessageOptions.includes(this.weddingInvitation.thankyouMessage)) {
          return this.weddingInvitation.thankyouMessage;
        }
        return '';
      },
      set(newValue) {
        this.weddingInvitation.thankyouMessage = newValue;
      }
    },
    partnerDetails() {
      if (!this.weddingInvitation.partnerSeq) {
        return [];
      }
      const selectedPartner = this.partnerListWithDetails.find(
        partner => partner.partnerSeq === this.weddingInvitation.partnerSeq
      );
      return selectedPartner ? selectedPartner.details : [];
    },
    campaignCategories2Depth() {
      if (!this.selected1DepthCampaignCategorySeq) {
        return [];
      }
      const selectedParent = this.campaignCategoryListWithChildren.find(
        category => category.seq === this.selected1DepthCampaignCategorySeq
      );

      return selectedParent ? selectedParent.children : [];
    },
    donationCategories2Depth() {
      if (!this.selected1DepthDonationCategorySeq) {
        return [];
      }
      const selectedParent = this.donationCategoryListWithChildren.find(
        donation => donation.seq === this.selected1DepthDonationCategorySeq
      );

      return selectedParent ? selectedParent.children : [];
    }
  },

  async mounted() {
    await this.requestCheckLogin();

    this.weddingInvitation = await this.requestWeddingInvitationForEdit(this.weddingInvitationSeq)
    const [selectedYear, selectedMonth, selectedDay] = this.weddingInvitation.eventDate.split('-');
    this.selectedYear = selectedYear
    this.selectedMonth = selectedMonth
    this.selectedDay = selectedDay
    this.attachList = this.weddingInvitation.attachList
    this.mainPhoto.name = this.weddingInvitation.mainImageName
    this.designs[this.weddingInvitation.mainDesign - 1].isSelected = true
    const [editType, editColor] = this.weddingInvitation.editStyle.split('_')
    this.editStyles[editType].isSelected = true
    this.editStyles[editType].selectedColor = editColor
    this.weddingInvitation.greetingsMessage = this.weddingInvitation.greetingsMessage.replace(/<br>/g, "\n");

    this.weddingInvitation.congratInfo.forEach(info => {
      if (info.weddingSide === 'groom') {
        this.groomCongratInfo.push(info)
      } else if (info.weddingSide === 'bride') {
        this.brideCongratInfo.push(info)
      }
    })

    const { currentPage, currentCategorySeq } = this;

    // await this.requestCampaignList({ currentPage, currentCategorySeq });
    // await this.requestCategoryList("캠페인");
    await this.requestPartnersWithDetails('wedding');
    await this.requestCampaignCategoryListWithChildren();
    await this.requestDonationCategoryListWithChildren();
    await this.requestFilteredCampaignList({
        categoryCampaignSeq: this.weddingInvitation.categoryCampaignSeq,
        categoryDonationSeq: this.weddingInvitation.categoryDonationSeq,
        campaignType: 'WEDDING'
      });

    const latitude = this.weddingInvitation.eventLatitude;
    const longitude = this.weddingInvitation.eventLongitude;
    this.initMap(latitude, longitude);
    //this.selectPlace({ place_name: "서울특별시청", x: longitude, y: latitude });
    if (this.weddingInvitation.partnerSeq) {
      const p = this.partnerListWithDetails
        .find(pp => pp.partnerSeq === this.weddingInvitation.partnerSeq);
      if (p?.name) this.updateMapByName(p.name);
    } else if (this.weddingInvitation.eventLocationName) {
      this.updateMapByName(this.weddingInvitation.eventLocationName);
    }

    if (this.weddingInvitation.categoryCampaignSeq) {
      const parentCampaignCategorySeq = this.findCampaignCategoryParentSeq(this.weddingInvitation.categoryCampaignSeq);

      if (parentCampaignCategorySeq) {
        this.selected1DepthCampaignCategorySeq = parentCampaignCategorySeq;
      }
    }

    if (this.weddingInvitation.categoryDonationSeq) {
      const parentDonationCategorySeq = this.findDonationCategoryParentSeq(this.weddingInvitation.categoryDonationSeq);

      if (parentDonationCategorySeq) {
        this.selected1DepthDonationCategorySeq = parentDonationCategorySeq;
      }
    }
  },

  watch: {
    eventDate(newDate) {
      this.weddingInvitation.eventDate = newDate;
    },
    currentCategorySeq(newVal) {
      this.getCategorizedCampaign(newVal);
    },
    'weddingInvitation.eventLocationName'(name) {
      const matchExists = this.partnerListWithDetails.some(
        partner => partner.name === name
      );
      if (!matchExists) {
        this.weddingInvitation.partnerSeq = null;
        this.selectedPartnerDetailSeq = null;
        // this.weddingInvitation.eventLocationDetail = '';
      }
    },
    'weddingInvitation.eventLocationDetail'(detailName) {
      const matchExists = this.partnerDetails.some(
        detail => detail.name === detailName
      );
      if (!matchExists) {
        this.selectedPartnerDetailSeq = null;
      }
    },
    selected1DepthCampaignCategorySeq(newValue, oldValue) {
      if(oldValue === undefined || oldValue === null) {
        return;
      }

      this.weddingInvitation.categoryCampaignSeq = null;
    },
    selected1DepthDonationCategorySeq(newValue, oldValue) {
      if(oldValue === undefined || oldValue === null) {
        return;
      }

      this.weddingInvitation.categoryDonationSeq = null;
    },
    'weddingInvitation.categoryCampaignSeq'(categoryCampaignSeq, oldValue) {
      if(oldValue === undefined || oldValue === null) {
        return;
      }

      this.weddingInvitation.campaignSeq = null;

      this.requestFilteredCampaignList({
        categoryCampaignSeq: categoryCampaignSeq,
        categoryDonationSeq: this.weddingInvitation.categoryDonationSeq,
        campaignType: 'WEDDING'
      });
    },
    'weddingInvitation.categoryDonationSeq'(categoryDonationSeq, oldValue) {
      if(oldValue === undefined || oldValue === null) {
        return;
      }

      this.weddingInvitation.campaignSeq = null;

      this.requestFilteredCampaignList({
        categoryCampaignSeq: this.weddingInvitation.categoryCampaignSeq,
        categoryDonationSeq: categoryDonationSeq,
        campaignType: 'WEDDING'
      });
    }
  }
};
</script>
